import React from 'react';
import Grid from '@material-ui/core/Grid'
import {
    AutocompleteArrayInput,
    BooleanInput,
    maxLength,
    ReferenceArrayInput,
    required,
    SelectInput,
    TextInput
} from 'react-admin';
import {AdmissionAdditionalServiceInput} from "../../components/AdmissionAdditionalService";
import {schoolYears} from "../../components";

const AdmissionAdditionalServiceFields = props => (
    <React.Fragment>
        <Grid item xs={12} sm={6}>
            <TextInput source="name" validate={[required(), maxLength(100, 'Không quá 100 ký tự')]} {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <AdmissionAdditionalServiceInput source="type" defaultValue={'PROGRAM'}
                                             validate={[required()]} {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <BooleanInput source="defaultValue" defaultValue={true} {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <BooleanInput source="forced" defaultValue={false} {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <ReferenceArrayInput source="admissionSubjectIds" reference="admissionSubjects" allowEmpty {...props} >
                <AutocompleteArrayInput optionText="name"/>
            </ReferenceArrayInput>
        </Grid>
        <Grid item xs={12} sm={6}>
            <SelectInput source="schoolYearId" choices={schoolYears} defaultValue={schoolYears[0]?.id}
                         InputProps={{readOnly: true}}
                         label='Niên khoá'
                         validate={required()}/>
        </Grid>
    </React.Fragment>
)

export default AdmissionAdditionalServiceFields
